export const PROMOTION_CONTACT_FILTERS_OPTIONS = [
	{
		label: 'Has no delivered order / online payment',
		value: 'noDeliveredOrderOrOnlinePayment',
	},
];